<template>
	<div class="dropdown" v-if="modelValue">
		<div class="dropdown__overlay" @click="$emit('update:modelValue', false)"></div>
		<div class="dropdown__content">
			<slot />
		</div>
	</div>
</template>

<script setup lang="ts">
defineProps<{
	modelValue: boolean
}>()

defineEmits<{
	'update:modelValue': [value: boolean]
}>()
</script>

<style>
.dropdown-enter-active,
.dropdown-leave-active {will-change:transform;transition:opacity .17s ease-out, transform .17s ease-out;transform-origin:0 0;}
.dropdown-leave-active {pointer-events:none;}
.dropdown-enter,
.dropdown-leave-to {opacity:0;transform:scaleY(.3);}
.dropdown {position:absolute;z-index:5;background:#fff;border-radius:var(--radius-xl);box-shadow:0 6px 8px rgba(50,50,62,.2);}
</style>
